/* global Modernizr */

import { Controller } from 'stimulus';

const SEARCH_FOCUS_TIMEOUT = 50;

class Search extends Controller {
  connect() {
    this.isOpen = this.element.classList.contains('is-open');
    this.searchTrigger = document.querySelector('.js-header-search-trigger');

    this.searchTrigger.addEventListener('click', (e) => {
      this.expandOrSearch(e);
    });
  }

  expandOrSearch(event) {
    if (!this.isOpen) {
      event.preventDefault();
      this.focusOnInput();
    }

    this.toggleSearch();
  }

  toggleSearch() {
    this.isOpen = !this.isOpen;

    this.element.classList.toggle('is-open', this.isOpen);

    if (Modernizr.mq('(min-width: 992px)')) {
      this.element.style.width = this.isOpen ? '400px' : '82px';
    }
  }

  focusOnInput() {
    setTimeout(() => {
      this.inputTarget.focus();
    }, SEARCH_FOCUS_TIMEOUT);
  }
}

Search.targets = [
  'input',
  'submit',
];

export default Search;
